import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import MassAdd from './mass_add';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import {request} from '../../containers/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import filtersSelectorGenerator from './filters';


export default class Students extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
        {field: item => item.login_counter.persian(true), label: 'تعداد ورود'}, 
        {field: item => item.last_login!==null?item.last_login.toJalali().persian() : '-', label: 'آخرین ورود'},
        {field: item => item.date_joined!==null?item.date_joined.toJalali().persian() : '-', label: 'تاریخ عضویت'},
        {field: "gender", label: window.gettext("Gender")},
        {field: item => item.grade ? item.grade.title : '-', label: window.gettext('Grade')},
        {field: item => item.school ? item.school.name : '-', label: window.gettext('School')},
        {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
        {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
        {field: 'national_id', label: window.gettext('National ID')},
    ]

    filtersSelector = filtersSelectorGenerator.bind(this)()

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('National ID')},
        {name: 'firstname', label: window.gettext('Firstname')},
        {name: 'lastname', label: window.gettext('Lastname')},
        {name: 'grade', label: window.gettext('Grade')},
        // {name:"gender" , label:window.gettext("gender")},
        {name: 'school', label: window.gettext('School')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                        {
                            label: window.gettext('Reset students'),
                            action: async () => {
                                if (!window.confirm(window.gettext('Are you sure you wanna reset all students schools?')))
                                    return;
                                await this.context.store.dispatch(request({
                                    path: '/student/reset_students_schools/',
                                    body: {id: this.props.store.getIn(['paginator', 'selected']).keySeq()},
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                            },
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        //add student btn 
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Student'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
                {
                    label: window.gettext('Add Group of Students'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'mass_add/',
                    )),
                },
                // {
                //     label: window.gettext('Reset students'),
                //     action: async () => {
                //         if (!window.confirm(window.gettext('Are you sure you wanna reset all students schools?')))
                //             return;
                //         if (this.props.store.getIn(['paginator', 'selected']).size > 0) {
                //             await this.context.store.dispatch(request({
                //                 path: '/student/reset_students_schools/',
                //                 body: {id: this.props.store.getIn(['paginator', 'selected']).keySeq()},
                //                 method: 'POST',
                //             }));
                //             this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                //         }
                //         else {
                //             if (!window.confirm(window.gettext('Are you sure you wanna reset all students schools?')))
                //                 return;
                //             if (!window.confirm(window.gettext('Are you sure you wanna reset all students schools?')))
                //                 return;
                //             await this.context.store.dispatch(request({
                //                 path: '/student/reset_students_schools/',
                //                 method: 'POST',
                //             }));
                //             this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
                //         }
                //     },
                // },
            ]),
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        if (this.props.params.id === 'mass_add')
            return <MassAdd
                store={this.props.store}
                refresh={() => {
                    const path = this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    );
                    this.context.store.dispatch([
                        push(path.split('/').slice(0, -2).join('/') + '/'),
                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                    ]);
                }}
            />;
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='student'
            title={window.gettext('Students')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
